// Two-decimal formatting, shared by every tab. Hours are shown to two places
// throughout the app (see the bookkeeping-tasks-and-time spec); doing it in
// one place keeps the tabs from drifting from each other.
export const money = (v) =>
  `$${Number(v || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const hours = (v) => Number(v || 0).toFixed(2);
